<template>
    <div>
        <div class="alert alert-danger" v-show="vErrors.has('team_capacity')">
            {{ vErrors.first('team_capacity') }}
        </div>

        <div class="alert alert-danger" v-show="this.remainingParticipantCapacity === 0">
            {{ $t('bulk_team_tickets.team_limit_reached') }}
        </div>

        <!--Pre-paid box-->
        <div :class="boxClass.box" class="mb-2">
            <h4 class="card-header" v-if="theme == 'bs4'">{{ this.registrationCategory.name }}</h4>
            <div :class="boxClass.boxHeader" v-else>
                {{ this.registrationCategory.name }}
            </div>

            <div :class="[boxClass.boxBody, boxClass.padding]" class="d-none d-sm-block">
                <table class="table">
                    <tr>
                        <th>{{ $t('bulk_team_tickets.team_name') }}</th>
                        <th>{{ $t('bulk_team_tickets.date') }}</th>
                        <th>{{ $t('bulk_team_tickets.price') }}</th>
                        <th class="text-right">{{ $t('bulk_team_tickets.ticket') }}</th>
                    </tr>
                    <tr>
                        <td class="align-middle"> {{ this.team.name }}</td>
                        <td class="align-middle">
                            {{
                                this.registrationCategory.date | dateFormat(this.registrationCategory.occasion.timezone,
                            "DD/MM/YY HH:mm")
                            }}
                        </td>
                        <td class="align-middle"> {{
                                (this.isFixedPricing ? 0 : this.registrationCategory.current_price.amount) |
                                    money(this.registrationCategory.current_price.currency)
                            }}
                        </td>
                        <td class="text-right">
                            <plus-minus-control
                                class="float-right"
                                style="display:inline-block"
                                v-model="tickets[registrationCategory.id]"
                                :disabled="!enabled"
                                :max="this.remainingParticipantCapacity"
                                :min="0"
                            ></plus-minus-control>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5" class="text-right">
                            {{ $t('bulk_team_tickets.total_tickets') }} {{ totalNumOfTickets }}
                            {{ $t('bulk_team_tickets.total_price') }} {{ totalPrice | money(this.registrationCategory.occasion.currency) }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-if="theme == 'bs4'" :class="[boxClass.boxBody, boxClass.padding]" class="mb-4 d-block d-sm-none">
            <ul class="list-group text-center mb-2">
                <li class="list-group-item">
                    <h4>{{ this.team.name }}</h4>
                    <p>{{
                            this.registrationCategory.date | dateFormat(this.registrationCategory.occasion.timezone,
                                "DD/MM/YY HH:mm")
                        }}</p>
                    <p>{{
                            (this.isFixedPricing ? 0 : this.registrationCategory.current_price.amount) |
                                money(this.registrationCategory.current_price.currency)
                        }}</p>
                    <p>
                        <status-badge :status="this.registrationCategory.human_status"></status-badge>
                    </p>
                    <p>
                        <plus-minus-control
                            style="display:inline-block"
                            v-model="tickets[registrationCategory.id]"
                            :disabled="!enabled"
                            :max="this.remainingParticipantCapacity"
                            :min="0"
                        ></plus-minus-control>
                    </p>
                </li>
            </ul>
            <div class="text-center">
                {{ $t('bulk_team_tickets.total_tickets') }} {{ totalNumOfTickets }}
                {{ $t('bulk_team_tickets.total_price') }} {{ totalPrice | money(this.registrationCategory.current_price.currency) }}
                <hr>
            </div>
        </div>

        <!--Submit button-->
        <b-button variant="success" :disabled="!enabled || !totalNumOfTickets || submitting" @click="submit"
                  :block="true">
            <span v-if="!submitting">{{ $t('bulk_team_tickets.continue') }}</span>
            <span v-else>{{ $t('bulk_team_tickets.submitting') }}</span>
        </b-button>
    </div>
</template>

<script>
import StatusBadge from '../StatusBadge.vue'
import PlusMinusControl from '../../AAA_TO_REFACTOR/PlusMinsControl.vue'
import {dateFormat} from '../../Utility/filters/dates'
import {money} from '../../Utility/filters/money'
import axios from 'axios'
import {mapField} from "../../FieldMappings/filters/mapField";
import ParseInt from "lodash-es/parseInt";
import boxClassMixin from "./mixins/boxClassMixin.js";
import formValidationMixin from "./mixins/formValidationMixin.js";

export default {
    name: "BulkTeamTickets",
    mixins: [boxClassMixin, formValidationMixin],
    components: {
        PlusMinusControl,
        StatusBadge,
    },
    filters: {
        money,
        dateFormat,
        mapField,
    },
    props: {
        registrationCategory: {
            type: Object,
            required: true,
        },
        userEntity: { // TODO: extremely insecure, change ASAP (Ben did not write this...)
            type: [Object, Boolean],
            required: false,
        },
        theme: {
            type: String,
            default: 'bs4',
        },
        transaction: {
            type: Object,
            required: false,
            default: () => ({})
        },
        team: {
            type: Object,
            required: true,
        },
        remainingParticipantCapacity: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            additionalTransactionValues: {},
            fields: ['name', 'date', 'price', 'ticket'],
            tickets: {},
            user: {
                id: '',
                first_name: '',
                last_name: '',
                confirmed: false
            },
            errorMessage: '',
        }
    },

    created() {
        this.$set(this.tickets, this.registrationCategory.id, 0);

        if (this.userEntity) {
            this.user = this.userEntity;
            this.user.confirmed = true;
        }
    },
    computed: {
        isFixedPricing() {
            return this.registrationCategory.team_pricing_strategy === 'overall';
        },
        totalPrice() {
            if (this.isFixedPricing) {
                return 0;
            }

            return Object.entries(this.tickets)
                .map(([key, val]) => this.registrationCategory.current_price.amount * val)
                .reduce((acc, i) => acc + i, 0)
        },
        totalNumOfTickets() {
            return Object.entries(this.tickets).reduce((acc, [key, val]) => acc + val, 0);
        },
        enabled() {
            return this.user.id;
        },
    },
    methods: {
        ParseInt,
        submit() {
            if (!this.validate()) {
                this.showValidationErrors = true;
                return false;
            } else {
                this.showValidationErrors = false;
            }

            this.$validator.validateAll('user').then((result) => {
                this.submitting = true;

                if (result) {
                    let additional_transaction_values = Object.entries(this.additionalTransactionValues)
                        .map(([addition_id, value]) => Object.assign({}, {
                            addition_id,
                            value,
                            'transaction_id': this.transaction.id
                        }));

                    this.transaction.user_id = this.user.id;
                    let transaction = this.transaction;

                    axios
                        .post('/api/v0/participants/bulk', {
                            additional_transaction_values,
                            occasion_id: this.registrationCategory.occasion_id,
                            tickets: this.tickets,
                            team: this.team,
                            transaction,
                            user: this.user,
                        })
                        .then((response) => {
                            let status = response.data.status;

                            if (status == "error") {

                                let errors = response.data.data.errors;
                                errors = Array.isArray(errors) ? errors : [errors];

                                //Inject errors to validator
                                this.handleSubmitErrors(errors);

                                this.submitting = false;
                            } else if (status == "success") {
                                //Redirect to basket
                                window.location = response.data.data.redirect
                            }
                        }).catch((response) => {
                            this.submitting = false;
                            alert(this.$t('bulk_team_tickets.save_error'));
                        })
                } else {
                    this.submitting = false;
                }

            }).catch(response => {
                alert(this.$t('bulk_team_tickets.general_error'))
            });
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Participants/Form/BulkTeamTickets.vue